export enum TierOrPlan {
    Free = 'FREE',
    Referral = 'REFERRAL',
    Hobbyist = 'HOBBYIST',
    Pro = 'PRO',
    PixelClassic = 'PIXELCLASSIC',
    PixelStudio = 'PIXELSTUDIO',
    Custom = 'CUSTOM',
    Signature = 'SIGNATURE',
    Elite = 'ELITE',
    Explorer = 'EXPLORER',
    Ignite = 'IGNITE',
    Students = 'STUDENTS',
}

export enum BillingCycle {
    Monthly = 'MONTHLY',
    Yearly = 'YEARLY',
    Lifetime = 'LIFETIME',
}
